<template lang="pug">
  v-container.px-10(fluid)
    v-progress-linear(
      :active="loading",
      indeterminate,
      color="white",
      absolute,
      top
    )
    v-row.mt-5(v-if="!loading")
      v-col.py-0
        v-card.elevation-24.mb-5
          app-full-entity(v-if="!loading", :ignoreTabs="groupTaskIgnoreTabs", :entity="customGroupTaskEntity", sectionIgnore, v-bind="{ tabsProps }")
    v-row.pb-10.pt-5.align-self-start(align="center", v-if="entity")
      v-col.py-0.text-right
        v-btn(color="#23AF82", dark, @click="save()", :disabled="disabledSave", v-if="ShowEntityEdit(entityName)") {{$t('Common.save')}}
</template>

<script>
import assign from 'lodash/assign'
import axios from 'axios'
import EntityMixin from '@/mixins'
import EntityLoadsMixin from "@/mixins/entity-loads.mixin";

export default {
  mixins: [EntityMixin, EntityLoadsMixin],
  name: 'Group',
  data: () => ({
    disabledSave: false,
    loading: true,
    errors: {},
    toSection: ['businessScope','groupTasks'],

    tabsProps: {
      backgroundColor: 'grisClair',
      color: 'primaryHover',
      dark: false,
    },
  }),

  computed: {
    entityName () {
      return 'Group'
    },
    entity () {
      return this.$findEntity('Group')
    },
    sectionedFields() {
      let { fields } = this.entity;
      fields = fields.map(f => {
        if (this.toSection.includes(f.name)) {
          return { ...f, section: 'Group' }
        }
        return f;
      });

      return fields;
    },
    sortedFields() {
      return [...this.sectionedFields].sort((a, b) => {
        const aValue = this.toSection.includes(a.name) ? this.toSection.indexOf(a.name) + 1 : 0;
        const bValue = this.toSection.includes(b.name) ? this.toSection.indexOf(b.name) + 1 : 0;

        if (aValue > bValue) return 1;
        if (bValue > aValue) return -1;

        return 0;
      });
    },
    customGroupTaskEntity() {
      let sectionedEntity = { ...this.entity };
      sectionedEntity.fields = this.sortedFields;
      return sectionedEntity;
    },
    uid () {
      return this.$route.params.item
    },
    loadExtraData() {
      return this.$isExtraDateable(this.entity) ? '?load[]=ExtraData' : ''
    },
    groupTaskIgnoreTabs() {
      return ['extraFields', 'groupPartyUsers', 'groupParty', 'groupTask', 'groupTaskUsers'];
    },
  },

  methods: {
    async save () {
      try {
        this.disabledSave = true;
        if (this.instance.businessScope == null || this.instance.businessScopeId === null) this.instance.businessScopeId = this.$getBusinessScopeId()
        var response = (await axios.post('entity/graph', this.instance))
        this.instance = response.data
        this.$router.push({
          name: 'entities.index',
          params: { entity: 'GroupTask' }
        })
      } catch (error) {
        this.errors = error.response.data.errors
        this.$store.commit('SET_ERRORS', this.errors)
      } finally {
        this.disabledSave = false;
      }
    },

    async load () {
      if (this.uid) {
        try {
          this.instance = (await axios.get(`${this.entity.name}/${this.uid}${this.loadExtraData}`, {
            _Entity: this.entity.name,
            uid: this.uid,
            params: {
              Load: [...this.$entityLoads(this.entity),'groupTasks.Task'],
            }
          })).data
          this.instance.entityState = 3
          this.$store.commit('SET_INSTANCE', this.instance)
        } catch (error) {
          console.error(error)
        }
      }
      this.loading = false
    }
  },

  created () {
    this.$store.commit('SET_INSTANCE', null)
  },

  async mounted () {
    await this.load()
  }
}
</script>
